import api from 'api';

export const loadUsers = api('GET /api/affiliates/fields/users');

export const loadActiveUsers = api('GET /api/affiliates/fields/users/active');

export const loadBusinessPartner = api(
  'GET /api/affiliates/fields/business-partner/:id'
);
export const loadBusinessPartnerDetails = api(
  'GET /api/affiliates/fields/business-partner-details/:id'
);

export const loadBusinessPartners = api(
  'GET /api/affiliates/fields/business-partners'
);

export const loadActiveBusinessPartners = api(
  'GET /api/affiliates/fields/business-partners/active'
);

export const loadExpenseTypes = api('GET /api/affiliates/fields/expense-types');

export const loadTrafficTypes = api('GET /api/affiliates/fields/traffic-types');

export const loadChannels = api('GET /api/affiliates/fields/channels');

export const loadApplications = api('GET /api/affiliates/fields/applications');

export const loadSpendSources = api('GET /api/affiliates/fields/spend-sources');

export const loadMediaSources = api('GET /api/affiliates/fields/media-sources');
